import styled from "styled-components";
const MultiSelectOptionWrapper = styled("li")(
  ({ theme }) => ({
    borderRadius: 2,
    "&:active": {
      backgroundColor: theme.color.gray4
    }
  }),
  ({ $highlighted, theme }) => $highlighted ? {
    backgroundColor: theme.color.gray3
  } : void 0
);
export {
  MultiSelectOptionWrapper
};
